const DAY = 24 * 60

/**
 * Sample run results. A schedule's run lands at its previous cron time, so it
 * always looks fresh; trigger runs (and the paused schedule's last run) are a
 * fixed number of minutes before page load.
 */
export const DEMO_UPDATES = [
  { id: 'demo-upd-support-pulse', sourceId: 'demo-sch-support-pulse' },
  { id: 'demo-upd-inbox-brief', sourceId: 'demo-sch-inbox-brief' },
  { id: 'demo-upd-competitor', sourceId: 'demo-sch-competitor-digest' },
  { id: 'demo-upd-pipeline', sourceId: 'demo-sch-pipeline' },
  { id: 'demo-upd-trademark', sourceId: 'demo-sch-trademark-watch' },
  { id: 'demo-upd-board-pack', sourceId: 'demo-sch-board-pack' },
  { id: 'demo-upd-release-notes', sourceId: 'demo-sch-release-notes', minutesAgo: 9 * DAY + 60 },
  { id: 'demo-upd-demo-request', sourceId: 'demo-trg-demo-request', minutesAgo: 47 },
  { id: 'demo-upd-github-bug', sourceId: 'demo-trg-github-bug', minutesAgo: 190 },
  { id: 'demo-upd-meeting-brief', sourceId: 'demo-trg-meeting-brief', minutesAgo: 300 },
  { id: 'demo-upd-closed-won', sourceId: 'demo-trg-closed-won', minutesAgo: 2 * DAY + 130 },
  { id: 'demo-upd-spec-edit', sourceId: 'demo-trg-spec-edit', minutesAgo: 11 * DAY },
]
